<script setup lang="ts">
import { computed, onMounted, ref, defineAsyncComponent } from "vue"
import { useRoute } from "vue-router"

const app = ref(null)

onMounted(() => {
    // Crée une instance de ResizeObserver
    const resizeObserver = new ResizeObserver((entries) => {
        // Boucle sur les entrées observées (généralement une seule ici)
        for (const entry of entries) {
            const newHeight = entry.target.clientHeight // Récupère la hauteur actuelle

            if (newHeight > 0) {
                window.parent.postMessage(
                    {
                        type: "update:clientHeight",
                        value: newHeight,
                    },
                    "*"
                )
            }
        }
    })
    if (app.value) {
        // Commence à observer les changements de dimensions
        resizeObserver.observe(app.value)
    }
})

const route = useRoute()

const layout = computed(() => {
    switch (route.meta.layout) {
        case "error":
            return defineAsyncComponent(
                () => import("@layouts/ErrorLayout.vue")
            )
        case "form":
            return defineAsyncComponent(() => import("@layouts/FormLayout.vue"))
        default:
        case "default":
            return defineAsyncComponent(
                () => import("@layouts/DefaultLayout.vue")
            )
    }
})
</script>

<template>
    <div ref="app">
        <component :is="layout">
            <KeepAlive>
                <RouterView v-slot="{ Component }" :key="$route.fullPath">
                    <component :is="Component"></component>
                </RouterView>
            </KeepAlive>
        </component>
    </div>
</template>
